import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import AdsComponent from "../adsComponent/adsComponent";
import Header from "../header/Header";
import { DEFAULT_NAVBAR_CATEGORY_COLOR, NAVBAR_CATEGORY_COLORS } from "../header/Navbar/categoryColors";
import "./screenInitializer.css";
import "./academicSubjectScroll.css";
import "./academicBackendLessons.css";
import { useLocation, useNavigate } from "react-router-dom";
import Footer from "../auth/views/footer/Footer";
import OTPInput from "otp-input-react";
import { Avatar, Button, Modal, Typography } from "@mui/material";
import AllPage from './AllPage'
import AcademicAllLessons from './AcademicAllLessons'
import { useDispatch, useSelector } from "react-redux";
import { protectted } from "../../redux/protectSlice";
import { Stack } from "@mui/system";
import { deepPurple } from "@mui/material/colors";
import { ReactComponent as Crossicon } from "../../assests/homeScreen/crossicon.svg";
import { useSnackbar } from "../../hook/useSnackbar";

const CATEGORY_SUBJECT_STRIP_MODULES = new Set([
  'academic',
  'early-career',
  'edutainment',
  'print-rich',
  'maker',
  'info-hub',
  'sections',
]);

const academicStageLessons = {
  FOUNDATIONAL: [
    'Pre-school shapes work sheets',
    'Number and pre-math work sheets',
    'Pre-school Concepts work sheets',
    'Pre-school Colouring work sheets',
    'Alphabet work sheets',
    'Activity work sheets',
  ],
  PREPARATORY: [
    'Alphabet activities',
    'Mathematics',
    'Shapes games',
    'Colourful activities',
    'Basic Concepts',
    'Vocabulary',
  ],
  MIDDLE: ['Count, Colour and Think', 'Times Tables', 'Number Detective', 'Secret Code', 'Number Patterns'],
  SECONDARY: ['Word World', 'Compound Words', 'Rhyming Fun', 'Alphabetical Order', 'Educational chart'],
};

// const devTools = require('browser-detect-devtools');
// const devToolsManager = devTools.Manager;
const ScreenInitializer = () => {
  const headerRef = React.useRef(null);
  const subjectMenuScrollRef = React.useRef(null);
  const selectedSubjectRef = React.useRef(null);
  const lessonMenuScrollRef = React.useRef(null);
  const lessonDropdownRef = React.useRef(null);
  const lessonMenuCloseTimerRef = React.useRef(null);
  const lessonMenuOpenedByHoverRef = React.useRef(false);
  const [subjectScrollState, setSubjectScrollState] = useState({ canScrollLeft: false, canScrollRight: false });
  const [lessonMenuPosition, setLessonMenuPosition] = useState({ top: 0, left: 0 });
  const [lessonHasOverflow, setLessonHasOverflow] = useState(false);
  const [showEnglishMenu, setShowEnglishMenu] = useState(false);
  const [showBoardMenu, setShowBoardMenu] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [isOpened, setIsOpened] = React.useState(false);
  const [mounted, setMounted] = React.useState(false);
  const [open, setOpen] = React.useState(true);
  const [OTP, setOTP] = useState();
  const { protectedCode, isProtected } = useSelector((state) => state.protecttedUser);
  const dispatch = useDispatch();
  const { displaySnackbar } = useSnackbar();
  const [showAllPage, setShowAllPage] = useState(false);
  const [selectedClass, setSelectedClass] = React.useState(null);
  const [selectedSubject, setSelectedSubject] = useState("ALL");
  const [selectedAcademicStage, setSelectedAcademicStage] = useState(null);
  const [showAcademicClassMenu, setShowAcademicClassMenu] = useState(false);
  const [backendAcademicSubjects, setBackendAcademicSubjects] = useState(null);
  const [academicBookType, setAcademicBookType] = useState(null);
  const [academicLessons, setAcademicLessons] = useState([]);
  const [selectedAcademicLesson, setSelectedAcademicLesson] = useState(null);
  const [academicLessonsLoading, setAcademicLessonsLoading] = useState(false);
  const [hoveredLessonSubject, setHoveredLessonSubject] = useState(null);
  const [hoveredLessonBookType, setHoveredLessonBookType] = useState(null);
  const [hoveredLessonOptions, setHoveredLessonOptions] = useState([]);
  const [hoveredLessonLoading, setHoveredLessonLoading] = useState(false);
  let path = location.pathname;
  const currentCategoryModule = location.pathname.toLowerCase().split('/')[2] || '';
  const hasCategorySubjectStrip = CATEGORY_SUBJECT_STRIP_MODULES.has(currentCategoryModule);
  const isClassPickerRow = (currentCategoryModule === 'academic' && showAcademicClassMenu)
    || (currentCategoryModule === 'sections' && !selectedClass);
  const categoryAccentColor = NAVBAR_CATEGORY_COLORS[currentCategoryModule] || DEFAULT_NAVBAR_CATEGORY_COLOR;
  const showCategoryBanner = currentCategoryModule === 'academic'
    ? !showAllPage && !selectedClass && !selectedAcademicLesson
    : !showAllPage && ['early-career', 'edutainment', 'print-rich'].includes(currentCategoryModule);

  const canHoverLessonMenus = ['academic', 'sections'].includes(currentCategoryModule)
    && Boolean(selectedClass)
    && !showAcademicClassMenu;
  const isPreviewingHoveredLessonSubject = canHoverLessonMenus && Boolean(hoveredLessonSubject);
  const dropdownSubject = isPreviewingHoveredLessonSubject ? hoveredLessonSubject : selectedSubject;
  const dropdownBookType = isPreviewingHoveredLessonSubject ? hoveredLessonBookType : academicBookType;
  const clearLessonMenuCloseTimer = () => {
    if (lessonMenuCloseTimerRef.current !== null) {
      window.clearTimeout(lessonMenuCloseTimerRef.current);
      lessonMenuCloseTimerRef.current = null;
    }
  };
  const scheduleLessonMenuClose = () => {
    if (!lessonMenuOpenedByHoverRef.current) return;
    clearLessonMenuCloseTimer();
    lessonMenuCloseTimerRef.current = window.setTimeout(() => {
      lessonMenuCloseTimerRef.current = null;
      lessonMenuOpenedByHoverRef.current = false;
      setShowEnglishMenu(false);
      setHoveredLessonSubject(null);
    }, 200);
  };

  useEffect(() => {
    if (showEnglishMenu) return undefined;
    if (lessonMenuCloseTimerRef.current !== null) {
      window.clearTimeout(lessonMenuCloseTimerRef.current);
      lessonMenuCloseTimerRef.current = null;
    }
    lessonMenuOpenedByHoverRef.current = false;
    setHoveredLessonSubject(null);
    return undefined;
  }, [showEnglishMenu]);

  useEffect(() => () => {
    if (lessonMenuCloseTimerRef.current !== null) {
      window.clearTimeout(lessonMenuCloseTimerRef.current);
    }
  }, []);

  useEffect(() => {
    const header = headerRef.current;
    if (!header) return undefined;
    const syncHeaderHeight = () => {
      document.documentElement.style.setProperty(
        '--myschool-header-height',
        `${Math.ceil(header.getBoundingClientRect().height)}px`
      );
    };
    syncHeaderHeight();
    const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(syncHeaderHeight) : null;
    observer?.observe(header);
    window.addEventListener('resize', syncHeaderHeight);
    return () => {
      observer?.disconnect();
      window.removeEventListener('resize', syncHeaderHeight);
    };
  }, []);

  useEffect(() => {
    const syncAcademicSubjectAnchors = () => {
      const strip = document.querySelector('.academicSubjectStrip');
      if (!strip) return;
      const headerAll = Array.from(document.querySelectorAll('.navbarMiddleMenus button'))
        .find((button) => button.textContent.trim().toUpperCase() === 'ALL');
      const trailingControl = document.querySelector('.logoDropdownWrapper');
      if (headerAll) {
        const headerRange = document.createRange();
        headerRange.selectNodeContents(headerAll);
        const headerTextRect = headerRange.getBoundingClientRect();
        const rowAll = strip.querySelector('.subjectItemFixedAll');
        const rowRange = rowAll ? document.createRange() : null;
        if (rowRange) rowRange.selectNodeContents(rowAll);
        const rowTextRect = rowRange?.getBoundingClientRect();
        const currentPadding = parseFloat(window.getComputedStyle(strip).paddingLeft) || 0;
        const headerCenter = (headerTextRect.left + headerTextRect.right) / 2;
        const rowCenter = rowTextRect ? (rowTextRect.left + rowTextRect.right) / 2 : null;
        const allLeft = rowCenter === null
          ? headerAll.getBoundingClientRect().left
          : currentPadding + headerCenter - rowCenter;
        const roundedAllLeft = Math.max(0, Math.round(allLeft));
        strip.style.setProperty('--academic-all-left', `${roundedAllLeft}px`);
        if (trailingControl) {
          const rightEdge = trailingControl.getBoundingClientRect().left + 24;
          strip.style.setProperty('--academic-subject-width', `${Math.max(220, Math.round(rightEdge - roundedAllLeft))}px`);
        }
        const classPicker = strip.querySelector('.subjectMenuScroll .subjectMenu.classPickerMenu');
        const headerEight = Array.from(document.querySelectorAll('.navbarMiddleMenus button.headerClassButton'))
          .find((button) => button.textContent.trim() === '8');
        const classItems = classPicker
          ? Array.from(classPicker.children).filter((item) => item.textContent.trim())
          : [];
        if (classPicker && headerEight && classItems.length > 1 && window.innerWidth > 768) {
          const itemWidths = classItems.map((item) => item.getBoundingClientRect().width);
          const firstRect = classItems[0].getBoundingClientRect();
          const headerEightRect = headerEight.getBoundingClientRect();
          const firstCenter = (firstRect.left + firstRect.right) / 2;
          const targetCenter = (headerEightRect.left + headerEightRect.right) / 2;
          const itemSpanWithoutGaps = itemWidths.reduce((total, width) => total + width, 0)
            - ((itemWidths[0] + itemWidths[itemWidths.length - 1]) / 2);
          const calculatedGap = (targetCenter - firstCenter - itemSpanWithoutGaps) / (classItems.length - 1);
          const measuredGap = Math.max(14, Math.min(37, calculatedGap));
          strip.style.setProperty('--academic-subject-gap', `${Math.round(measuredGap * 10) / 10}px`);
        } else if (window.innerWidth <= 768) {
          strip.style.setProperty('--academic-subject-gap', '24px');
        }
      }
    };
    syncAcademicSubjectAnchors();
    const retryTimers = [0, 120, 400, 900].map((delay) => window.setTimeout(syncAcademicSubjectAnchors, delay));
    window.addEventListener('resize', syncAcademicSubjectAnchors);
    return () => {
      retryTimers.forEach((timer) => window.clearTimeout(timer));
      window.removeEventListener('resize', syncAcademicSubjectAnchors);
    };
  }, [location.pathname, selectedSubject, showAllPage]);

  useEffect(() => {
    if (currentCategoryModule === 'academic') {
      const incomingAcademicSelection = location.state?.academicSelection;
      if (incomingAcademicSelection?.selectedClass && incomingAcademicSelection?.selectedSubject && incomingAcademicSelection?.lesson) {
        setSelectedClass(incomingAcademicSelection.selectedClass);
        setSelectedSubject(incomingAcademicSelection.selectedSubject);
        setSelectedAcademicStage(null);
        setShowAcademicClassMenu(false);
        setAcademicBookType(incomingAcademicSelection.bookType || null);
        setAcademicLessons([]);
        setSelectedAcademicLesson(incomingAcademicSelection.lesson);
        setShowAllPage(false);
        setShowEnglishMenu(false);
        return;
      }
      setSelectedClass(null);
      setSelectedSubject('ALL');
      setSelectedAcademicStage(null);
      setShowAcademicClassMenu(true);
      setShowAllPage(false);
      setShowEnglishMenu(false);
      return;
    }

    if (!CATEGORY_SUBJECT_STRIP_MODULES.has(currentCategoryModule)) return;
    setSelectedClass(null);
    setSelectedSubject('ALL');
    setSelectedAcademicStage(null);
    setShowAcademicClassMenu(currentCategoryModule === 'sections');
    setSelectedAcademicLesson(null);
    setAcademicBookType(null);
    setAcademicLessons([]);
    setShowAllPage(false);
    setShowEnglishMenu(false);
  }, [location.pathname, currentCategoryModule, location.state]);

  const handleClose = () => {
    if (protectedCode == OTP) {
      setOpen(false);
    }
    else {
      displaySnackbar({ message: 'Please Enter The PassCode' });
    }
  };
  const checkUser = () => {
    if (protectedCode == OTP) {
      setOpen(false);
      dispatch(protectted());
      return
    } else {
      displaySnackbar({ message: 'Please Enter The Write PassCode' });
    }
  };
 const currentSection = location.pathname.split("/").pop();

useEffect(() => {
  const handleClassSelected = (event) => {
    if (!['academic', 'sections'].includes(currentCategoryModule)) return;
    console.log("Received class:", event.detail);

    setBackendAcademicSubjects(null);
    setSelectedClass(event.detail);
    setSelectedSubject("ALL");
    setSelectedAcademicStage(null);
    setShowAcademicClassMenu(event.detail === null);
    setAcademicBookType(null);
    setAcademicLessons([]);
    setSelectedAcademicLesson(null);
    setShowAllPage(false);
    setShowEnglishMenu(false);
  };

  window.addEventListener(
    "academic-class-selected",
    handleClassSelected
  );

  return () => {
    window.removeEventListener(
      "academic-class-selected",
      handleClassSelected
    );
  };
}, [currentCategoryModule]);

useEffect(() => {
  const handleAllLessonSelected = (event) => {
    const detail = event.detail || {};
    if (!detail.selectedSubject) return;
    setSelectedSubject(detail.selectedSubject);
    setAcademicBookType(detail.bookType || null);
    setSelectedAcademicLesson(detail.lesson || null);
    setShowAllPage(false);
    setShowEnglishMenu(false);
  };

  window.addEventListener('academic-all-lesson-selected', handleAllLessonSelected);
  return () => window.removeEventListener('academic-all-lesson-selected', handleAllLessonSelected);
}, []);

useEffect(() => {
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const supportsAcademicLessonMenu = ['academic', 'sections'].includes(currentCategoryModule);
  if (!backendUrl || !selectedClass || selectedSubject === 'ALL' || !supportsAcademicLessonMenu) {
    setAcademicBookType(null);
    setAcademicLessons([]);
    setSelectedAcademicLesson(null);
    return undefined;
  }

  const normalizedClass = String(selectedClass).toUpperCase();
  const classLevel = ['KG', 'LKG', 'UKG'].includes(normalizedClass)
    ? normalizedClass
    : normalizedClass.startsWith('CLASS-') ? normalizedClass : `CLASS-${normalizedClass}`;
  let cancelled = false;
  setAcademicLessonsLoading(true);

  const loadLessons = async () => {
    try {
      const bookTypesResponse = await fetch(`${backendUrl}/api/rest/academic/book-types`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ class_level: classLevel, subject: selectedSubject }),
      });
      const bookTypesData = bookTypesResponse.ok ? await bookTypesResponse.json() : {};
      const bookType = bookTypesData.book_types?.[0] || null;
      if (cancelled) return;
      setAcademicBookType(bookType);
      if (!bookType) {
        setAcademicLessons([]);
        return;
      }

      const lessonsResponse = await fetch(`${backendUrl}/api/rest/academic/unit-lessons`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ class_level: classLevel, subject: selectedSubject, book_type: bookType }),
      });
      const lessonsData = lessonsResponse.ok ? await lessonsResponse.json() : {};
      const lessons = Array.isArray(lessonsData.unit_lessons) ? lessonsData.unit_lessons : [];
      if (!cancelled) setAcademicLessons(lessons);
    } catch (error) {
      console.error('Error fetching Academic lessons:', error);
      if (!cancelled) {
        setAcademicBookType(null);
        setAcademicLessons([]);
      }
    } finally {
      if (!cancelled) setAcademicLessonsLoading(false);
    }
  };

  loadLessons();
  return () => { cancelled = true; };
}, [location.pathname, currentCategoryModule, selectedClass, selectedSubject]);

useEffect(() => {
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  if (!backendUrl || !selectedClass || !hoveredLessonSubject || !canHoverLessonMenus) {
    setHoveredLessonBookType(null);
    setHoveredLessonOptions([]);
    setHoveredLessonLoading(false);
    return undefined;
  }

  const normalizedClass = String(selectedClass).toUpperCase();
  const classLevel = ['KG', 'LKG', 'UKG'].includes(normalizedClass)
    ? normalizedClass
    : normalizedClass.startsWith('CLASS-') ? normalizedClass : `CLASS-${normalizedClass}`;
  let cancelled = false;
  setHoveredLessonBookType(null);
  setHoveredLessonOptions([]);
  setHoveredLessonLoading(true);

  const loadHoveredSubjectLessons = async () => {
    try {
      const bookTypesResponse = await fetch(`${backendUrl}/api/rest/academic/book-types`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ class_level: classLevel, subject: hoveredLessonSubject }),
      });
      const bookTypesData = bookTypesResponse.ok ? await bookTypesResponse.json() : {};
      const bookType = bookTypesData.book_types?.[0] || null;
      if (cancelled) return;
      setHoveredLessonBookType(bookType);
      if (!bookType) {
        setHoveredLessonOptions([]);
        return;
      }

      const lessonsResponse = await fetch(`${backendUrl}/api/rest/academic/unit-lessons`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ class_level: classLevel, subject: hoveredLessonSubject, book_type: bookType }),
      });
      const lessonsData = lessonsResponse.ok ? await lessonsResponse.json() : {};
      const lessons = Array.isArray(lessonsData.unit_lessons) ? lessonsData.unit_lessons : [];
      if (!cancelled) setHoveredLessonOptions(lessons);
    } catch (error) {
      console.error('Error fetching hovered Academic lessons:', error);
      if (!cancelled) {
        setHoveredLessonBookType(null);
        setHoveredLessonOptions([]);
      }
    } finally {
      if (!cancelled) setHoveredLessonLoading(false);
    }
  };

  loadHoveredSubjectLessons();
  return () => { cancelled = true; };
}, [currentCategoryModule, selectedClass, hoveredLessonSubject, canHoverLessonMenus]);

useEffect(() => {
  if (!location.pathname.toLowerCase().includes('/views/academic')) return undefined;
  window.dispatchEvent(new CustomEvent('academic-selection-changed', {
    detail: { selectedClass, selectedSubject, bookType: academicBookType, lesson: selectedAcademicLesson },
  }));
  return undefined;
}, [location.pathname, selectedClass, selectedSubject, academicBookType, selectedAcademicLesson]);

useEffect(() => {
  const usesAcademicSubjectCatalog = ['academic', 'sections'].includes(currentCategoryModule);
  if (!usesAcademicSubjectCatalog || (currentCategoryModule === 'sections' && !selectedClass)) {
    setBackendAcademicSubjects(null);
    return undefined;
  }

  const classGroups = {
    foundational: ['KG', 'LKG', 'UKG', '1', '2'],
    preparatory: ['3', '4', '5'],
    middle: ['6', '7', '8'],
    secondary: ['9', '10', '11', '12'],
  };
  const classesToLoad = selectedClass ? [selectedClass] : Object.values(classGroups).flat();
  const toBackendClassLevel = (classLevel) => {
    const normalized = String(classLevel).toUpperCase();
    return ['KG', 'LKG', 'UKG'].includes(normalized)
      ? normalized
      : normalized.startsWith('CLASS-') ? normalized : `CLASS-${normalized}`;
  };
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  let cancelled = false;

  const loadAcademicSubjects = async () => {
    if (!backendUrl) {
      setBackendAcademicSubjects(null);
      return;
    }

    try {
      const responses = await Promise.all(classesToLoad.map(async (classLevel) => {
        const response = await fetch(`${backendUrl}/api/rest/academic/subjects`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ class_level: toBackendClassLevel(classLevel) }),
        });
        if (!response.ok) return [];
        const data = await response.json();
        return Array.isArray(data.subjects) ? data.subjects : [];
      }));

      if (!cancelled) {
        const subjects = [...new Set(responses.flat()
          .map((subject) => String(subject).trim())
          .filter(Boolean))]
          .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));
        setBackendAcademicSubjects(subjects);
      }
    } catch (error) {
      console.error('Error fetching Academic subjects:', error);
      if (!cancelled) setBackendAcademicSubjects(null);
    }
  };

  loadAcademicSubjects();
  return () => { cancelled = true; };
}, [location.pathname, selectedClass, currentCategoryModule]);
const subjectMenus = {
  "academic": [
    { name: "ALL", color: "#5e94fe" },
    { name: "ENGLISH", color: "#5e94fe" },
    { name: "MATHEMATICS", color: "#5e94fe" },
    { name: "EVS", color: "#5e94fe" },
    { name: "SCIENCE", color: "#5e94fe" },
    { name: "SOCIAL SCIENCE", color: "#5e94fe" },
    { name: "ART & CRAFT", color: "#5e94fe" },
    { name: "PHYSICAL EDUCATION", color: "#5e94fe" },
    // { name: "COMPUTERS", color: "#5e94fe" },
    { name: "MORE...", color: "#5e94fe" }
  ],
  "early-career": [
    { name: "ALL", color: "#76ad47" },
    { name: "ENGLISH", color: "#76ad47" },
    { name: "MATHEMATICS", color: "#76ad47" },
    { name: "EVS", color: "#76ad47" },
    { name: "SCIENCE", color: "#76ad47" },
    { name: "SOCIAL SCIENCE", color: "#76ad47" },
    { name: "ART & CRAFT", color: "#76ad47" },
    { name: "PHYSICAL EDUCATION", color: "#76ad47" },
    // { name: "COMPUTERS", color: "#5e94fe" },
    { name: "MORE...", color: "#76ad47" }
  ],
  // "early-career": [
  //   { name: "ALL", color: "#76ad47" },
  //   { name: "ENGLISH", color: "#76ad47" },
  //   { name: "MATHEMATICS", color: "#76ad47" },
  //   { name: "EVS", color: "#76ad47" },
  //   { name: "SCIENCE", color: "#76ad47" },
  //   { name: "SOCIAL SCIENCE", color: "#76ad47" },
  //   { name: "ART & CRAFT", color: "#76ad47" },
  //   { name: "PHYSICAL EDUCATION", color: "#76ad47" },
  //   { name: "COMPUTERS", color: "#76ad47" },
  //       { name: "SKILLS", color: "#76ad47" },
  //   { name: "MORE...", color: "#76ad47" }
  // ],

  "edutainment": [
    { name: "ALL", color: "#ff8000" },
    { name: "Learn art", color: "#ff8000" },
    { name: "Brainy activities", color: "#ff8000" },
    { name: "Skillset magazines", color: "#ff8000" },
    { name: "Fun science", color: "#ff8000" },
    { name: "Read comics", color: "#ff8000" },
        { name: "comics", color: "#ff8000" },

    { name: "Outdoor games", color: "#ff8000" },
    { name: "More...", color: "#ff8000" }
  ],

  "print-rich": [
    { name: "ALL", color: "#ff0592" },
    { name: "Stories", color: "#ff0592" },
    { name: "pictorial stories", color: "#ff0592" },
    { name: "Comics", color: "#ff0592" },
    { name: "Bio graphics", color: "#ff0592" },
    { name: "Life lessons", color: "#ff0592" },
    { name: "Comic strips", color: "#ff0592" },
        { name: "C strips", color: "#ff0592" },
    { name: "Bloopers", color: "#ff0592" },
    { name: "More...", color: "#ff0592" }
  ],

  "maker": [
    { name: "ALL", color: "#a06ad9" },
    { name: "First learners books", color: "#a06ad9" },
    { name: "School books", color: "#a06ad9" },
    { name: "GK & Science books", color: "#a06ad9" },
    { name: "Language books", color: "#a06ad9" },
    { name: "Creative books", color: "#a06ad9" },
        { name: "Comic strips A", color: "#a06ad9" },

    { name: "More...", color: "#a06ad9" }
  ],

  "info-hub": [
    { name: "ALL", color: "#07c9a6" },
    { name: "101 Great days", color: "#07c9a6" },
    { name: "My science lab", color: "#07c9a6" },
    { name: "Outdoor games", color: "#07c9a6" },
    { name: "essay writing resources", color: "#07c9a6" },
    { name: "My Hobby ideas", color: "#07c9a6" },
      { name: "Comic strips A", color: "#07c9a6" },
    { name: "More...", color: "#07c9a6" }
  ]
};

const foundationalSubjectMenus = {
  KG: [
    { name: "ALL" },
    { name: "Alphabet" },
    { name: "Shapes" },
    { name: "Colours" },
  ],
  LKG: [
    { name: "ALL" },
    { name: "Alphabet" },
    { name: "Cursive writing" },
    { name: "Shapes" },
    { name: "Colours" },
  ],
  UKG: [
    { name: "ALL" },
    { name: "Alphabet" },
    { name: "Cursive writing" },
    { name: "Shapes" },
    { name: "Circles" },
    { name: "Colours" },
    { name: "Basic concepts" },
    { name: "Opposites" },
    { name: "Vocabulary" },
  ],
  "1": [
    { name: "ALL" },
    { name: "English" },
    { name: "Mathematics" },
    { name: "EVS" },
  ],
  "2": [
    { name: "ALL" },
    { name: "English" },
    { name: "Mathematics" },
    { name: "EVS" },
  ],
  "3": [
    { name: "ALL" },
    { name: "English" },
    { name: "Mathematics" },
    { name: "EVS" },
  ],
  "4": [
    { name: "ALL" },
    { name: "English" },
    { name: "Mathematics" },
    { name: "Science" },
    { name: "Social Studies" },
  ],
  "5": [
    { name: "ALL" },
    { name: "English" },
    { name: "Mathematics" },
    { name: "Science" },
    { name: "Social Studies" },
  ],
  "6": [
    { name: "ALL" },
    { name: "English" },
    { name: "Mathematics" },
    { name: "Science" },
    { name: "Social Studies" },
    { name: "Hindi" },
  ],
  "7": [
    { name: "ALL" },
    { name: "English" },
    { name: "Mathematics" },
    { name: "Science" },
    { name: "Social Studies" },
    { name: "Hindi" },
  ],
  "8": [
    { name: "ALL" },
    { name: "English" },
    { name: "Mathematics" },
    { name: "Science" },
    { name: "Social Studies" },
    { name: "Hindi" },
  ],
  "9": [
    { name: "ALL" },
    { name: "English" },
    { name: "Mathematics" },
    { name: "Physics" },
    { name: "Chemistry" },
    { name: "Biology" },
    { name: "Social Studies" },
  ],
  "10": [
    { name: "ALL" },
    { name: "English" },
    { name: "Mathematics" },
    { name: "Physics" },
    { name: "Chemistry" },
    { name: "Biology" },
    { name: "Social Studies" },
  ],
  "11": [
    { name: "ALL" },
    { name: "English" },
    { name: "Mathematics" },
    { name: "Physics" },
    { name: "Chemistry" },
    { name: "Biology" },
    { name: "Computer Science" },
  ],
  "12": [
    { name: "ALL" },
    { name: "English" },
    { name: "Mathematics" },
    { name: "Physics" },
    { name: "Chemistry" },
    { name: "Biology" },
    { name: "Computer Science" },
  ],
};

const fallbackAcademicSubjects = selectedClass
  ? foundationalSubjectMenus[selectedClass] || []
  : subjectMenus[currentSection] || subjectMenus.academic;
const usesBackendAcademicSubjects = ['academic', 'sections'].includes(currentCategoryModule);
const currentSubjects = usesBackendAcademicSubjects && backendAcademicSubjects !== null
  ? [{ name: 'ALL', color: '#5e94fe' }, ...backendAcademicSubjects.map((name) => ({ name, color: '#5e94fe' }))]
  : fallbackAcademicSubjects;
  const showAcademicStageMenu = location.pathname.toLowerCase().includes('/views/academic')
    && showAllPage
    && !selectedClass
    && (selectedSubject === 'ALL' || selectedAcademicStage);
  const showAcademicEntryMenu = location.pathname.toLowerCase().includes('/views/academic')
    && !showAllPage
    && !selectedClass
    && selectedSubject === 'ALL'
    && !selectedAcademicStage;
  const showAcademicCategoryMenu = location.pathname.toLowerCase().includes('/views/academic')
    && !showAllPage
    && !selectedClass
    && Boolean(selectedAcademicStage);
  const academicStageSubjects = [
    { name: 'FOUNDATIONAL', color: '#5e94fe' },
    { name: 'PREPARATORY', color: '#5e94fe' },
    { name: 'MIDDLE', color: '#5e94fe' },
    { name: 'SECONDARY', color: '#5e94fe' },
  ];
  const academicClassSubjects = ['KG', 'LKG', 'UKG', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12']
    .map((name) => ({ name, color: '#5e94fe' }));
  const subjectsToDisplay = showAcademicClassMenu
    ? [{ name: 'ALL', color: '#5e94fe' }, ...academicClassSubjects]
    : (showAcademicEntryMenu || showAcademicCategoryMenu)
    ? [{ name: 'ALL', color: '#5e94fe' }, ...academicStageSubjects]
    : showAcademicStageMenu
    ? [{ name: 'ALL', color: '#5e94fe' }, ...academicStageSubjects]
    : currentSubjects;
  const subjectRowOptions = subjectsToDisplay.filter((subject) => {
    const label = String(subject.label || subject.name || '').trim();
    return !/^more(?:\s*(?:\.\.\.|…))?$/i.test(label);
  });
  const dropdownLessons = isPreviewingHoveredLessonSubject
    ? hoveredLessonOptions
    : selectedAcademicStage && !selectedClass
      ? academicStageLessons[selectedAcademicStage] || []
      : academicLessons;
  const dropdownLoading = isPreviewingHoveredLessonSubject
    ? hoveredLessonLoading
    : selectedAcademicStage && !selectedClass ? false : academicLessonsLoading;
  console.log("Selected class:", selectedClass);
console.log("Subjects:", currentSubjects);

  useEffect(() => {
    const scrollElement = subjectMenuScrollRef.current;
    if (!scrollElement) return undefined;
    scrollElement.scrollLeft = 0;

    const updateSubjectScrollState = () => {
      const canScrollLeft = scrollElement.scrollLeft > 4;
      const canScrollRight = scrollElement.scrollLeft + scrollElement.clientWidth < scrollElement.scrollWidth - 4;
      setSubjectScrollState({ canScrollLeft, canScrollRight });
    };
    scrollElement.addEventListener('scroll', updateSubjectScrollState, { passive: true });
    const observer = new ResizeObserver(updateSubjectScrollState);
    observer.observe(scrollElement);
    const subjectRowContent = scrollElement.querySelector('.subjectMenu');
    if (subjectRowContent) observer.observe(subjectRowContent);
    updateSubjectScrollState();
    return () => {
      scrollElement.removeEventListener('scroll', updateSubjectScrollState);
      observer.disconnect();
    };
  }, [location.pathname, subjectRowOptions.length, selectedClass]);

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    if (!showEnglishMenu || !selectedSubjectRef.current) return undefined;
    const updateLessonMenuPosition = () => {
      const anchor = selectedSubjectRef.current;
      if (!anchor) return;
      const rect = anchor.getBoundingClientRect();
      const viewportWidth = document.documentElement.clientWidth || window.innerWidth;
      const margin = 8;
      const menuWidth = Math.min(
        lessonDropdownRef.current?.getBoundingClientRect().width || 320,
        viewportWidth - margin * 2
      );
      let left = rect.left;
      if (left + menuWidth > viewportWidth - margin) {
        left = rect.right - menuWidth;
      }
      left = Math.max(margin, Math.min(left, viewportWidth - menuWidth - margin));
      const top = rect.bottom + 4;
      setLessonMenuPosition((current) => (
        current.top === top && current.left === left ? current : { top, left }
      ));
    };
    updateLessonMenuPosition();
    window.addEventListener('resize', updateLessonMenuPosition);
    window.addEventListener('scroll', updateLessonMenuPosition, { passive: true });
    const subjectScrollElement = subjectMenuScrollRef.current;
    subjectScrollElement?.addEventListener('scroll', updateLessonMenuPosition, { passive: true });
    return () => {
      window.removeEventListener('resize', updateLessonMenuPosition);
      window.removeEventListener('scroll', updateLessonMenuPosition);
      subjectScrollElement?.removeEventListener('scroll', updateLessonMenuPosition);
    };
  }, [hoveredLessonSubject, selectedSubject, showEnglishMenu]);

  useEffect(() => {
    const scrollElement = lessonMenuScrollRef.current;
    if (!showEnglishMenu || !scrollElement) {
      setLessonHasOverflow(false);
      return undefined;
    }
    const updateLessonOverflow = () => {
      setLessonHasOverflow(scrollElement.scrollHeight > scrollElement.clientHeight + 1);
    };
    const observer = new ResizeObserver(updateLessonOverflow);
    observer.observe(scrollElement);
    updateLessonOverflow();
    return () => observer.disconnect();
  }, [showEnglishMenu, dropdownLessons.length, dropdownLoading]);

  useEffect(() => {
    if (!showEnglishMenu) return undefined;
    const closeLessonMenuOutside = (event) => {
      if (!lessonDropdownRef.current?.contains(event.target)) {
        setShowEnglishMenu(false);
      }
    };
    document.addEventListener('mousedown', closeLessonMenuOutside);
    return () => document.removeEventListener('mousedown', closeLessonMenuOutside);
  }, [showEnglishMenu]);
  if (isOpened) {
    return <Navigate to={"/unauthorized"} />;
  } else {
    return (
      <div className="screenInitializerContainer">
        <Header
  ref={headerRef}
  onSelectClass={(className) => {
    setSelectedClass(className);
    setSelectedSubject("ALL");
    setShowAllPage(false);
    setShowEnglishMenu(false);
  }}
/>
        {isProtected && path !== '/views/privacy' ?
          <Modal open={open}>
            <div
              style={{
                width: "500px",
                height: "400px",
                backgroundColor: "whitesmoke",
                display: "flex",
                flexDirection: "column",
                gap: "40px",
                borderRadius: "20px",
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                <Crossicon onClick={handleClose} />
              </div>
              <div style={{ display: 'flex', flex: '1', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: '40px' }}>
              
                <Typography variant="h1" fontSize={"25px"}>
                  Verify It Is You
                </Typography>
                <Typography>Validate This Device By Entering The OTP</Typography>
                <OTPInput
                  value={OTP}
                  onChange={setOTP}
                  autoFocus
                  OTPLength={3}
                  otpType="number"
                  disabled={false}
                  secure
                />
                <div>
                  <Button variant="contained" color="success" className="protedtedButton" fullwidth onClick={checkUser}>
                    Continue
                  </Button>
                </div>
              </div>
            </div>
          </Modal>
          : null}
        

        <div
          className={`screenInitializerWrapper ${hasCategorySubjectStrip ? 'academicScreenInitializer' : ''}`}
          data-category-module={currentCategoryModule}
          style={hasCategorySubjectStrip ? { '--category-accent': categoryAccentColor } : undefined}
        >
  {(!location.search || location.pathname.toLowerCase().includes('/views/academic')) && location.pathname !== "/views/privacy" ? (
    <>
     {/* New White Row */}
    <div
      className={`topWhiteMenuBar ${hasCategorySubjectStrip ? 'academicSubjectStrip' : ''} ${isClassPickerRow ? 'classPickerStrip' : ''}`}
    >
      <div className="subjectMenuViewport">
        {subjectRowOptions.filter((subject) => subject.name === 'ALL').map((subject) => {
          const isActive = selectedSubject === subject.name && showAllPage;
          return (
            <span
              key={subject.name}
              className={isActive ? "subjectItemActive subjectItemFixedAll" : "subjectItem subjectItemFixedAll"}
              aria-pressed={isActive}
              onClick={() => {
                const headerAll = [...document.querySelectorAll('.navbarMiddleMenus button')]
                  .find((button) => button.textContent.trim().toUpperCase() === 'ALL');
                const preserveSelectedAcademicClass =
                  currentCategoryModule === 'academic' && Boolean(selectedClass);
                if (!preserveSelectedAcademicClass) {
                  headerAll?.click();
                }
                setSelectedSubject('ALL');
                setSelectedAcademicStage(null);
                setShowAcademicClassMenu(
                  ['academic', 'sections'].includes(currentCategoryModule) && !preserveSelectedAcademicClass
                );
                  setSelectedAcademicLesson(null);
                  setShowAllPage(true);
                  setShowEnglishMenu(false);
              }}
              style={{
                color: hasCategorySubjectStrip ? 'var(--category-accent, #5e94fe)' : subject.color,
                border: isActive
                  ? (hasCategorySubjectStrip ? '1px solid var(--category-accent, #6d9be9)' : '1px solid #6d9be9')
                  : '1px solid transparent',
                borderRadius: isActive ? '4px' : undefined,
                borderBottomColor: isActive
                  ? (hasCategorySubjectStrip ? 'var(--category-accent, #6d9be9)' : subject.color)
                  : 'transparent',
                fontWeight: isActive ? 600 : 500,
              }}
            >
              {subject.name}
            </span>
          );
        })}
        <div className="subjectMenuScroll" ref={subjectMenuScrollRef}>
          <div className={`subjectMenu ${isClassPickerRow ? 'classPickerMenu' : ''}`}>
{subjectRowOptions.filter((subject) => subject.name !== 'ALL').map((subject) => {
  const isActive = selectedSubject === subject.name;
  const isLessonMenuAnchor = canHoverLessonMenus
    ? hoveredLessonSubject === subject.name || (!hoveredLessonSubject && showEnglishMenu && isActive)
    : isActive;

  return (
    <span
      key={subject.name}
      ref={isLessonMenuAnchor ? selectedSubjectRef : null}
      onMouseEnter={() => {
        if (!canHoverLessonMenus) return;
        clearLessonMenuCloseTimer();
        lessonMenuOpenedByHoverRef.current = true;
        setHoveredLessonSubject(subject.name);
        setShowEnglishMenu(true);
      }}
      onMouseLeave={() => {
        if (canHoverLessonMenus) scheduleLessonMenuClose();
      }}
      onClick={() => {
        setSelectedSubject(subject.name);
        setSelectedAcademicLesson(null);

        if (showAcademicClassMenu) {
          const headerClassButton = [...document.querySelectorAll('.navbarMiddleMenus button.headerClassButton')]
            .find((button) => button.textContent.trim().toUpperCase() === String(subject.name).trim().toUpperCase());
          if (headerClassButton) {
            headerClassButton.click();
          } else {
            window.dispatchEvent(new CustomEvent('academic-class-selected', { detail: subject.name }));
          }
          return;
        }

        if (showAcademicStageMenu || showAcademicEntryMenu || showAcademicCategoryMenu) {
          setSelectedAcademicStage(subject.name);
          setShowAllPage(false);
          setShowEnglishMenu(true);
          return;
        }

        if (subject.name === "ALL") {
          setSelectedAcademicStage(null);
          setShowAllPage(true);
          setShowEnglishMenu(false);
        } else {
          setShowAllPage(false);
          setShowEnglishMenu(true);
        }
      }}
      className={
        isActive ? "subjectItemActive" : "subjectItem"
      }
      style={{
        color: hasCategorySubjectStrip ? 'var(--category-accent, #5e94fe)' : subject.color,
        borderBottomColor: isActive
          ? (hasCategorySubjectStrip ? 'var(--category-accent, #5e94fe)' : subject.color)
          : "transparent",
      }}
    >
      {subject.name}
    </span>
  );
})}
          </div>
        </div>
        {(!showAcademicStageMenu && (subjectRowOptions.length > 5 || subjectScrollState.canScrollRight || subjectScrollState.canScrollLeft)) && (
          <button
            type="button"
            className="subjectMenuScrollButton subjectMenuNextButtonBelow"
            aria-label={subjectScrollState.canScrollRight || !subjectScrollState.canScrollLeft ? "Scroll subjects right" : "Scroll subjects left"}
            onClick={() => {
              const scrollElement = subjectMenuScrollRef.current;
              if (!scrollElement) return;
              const pageWidth = Math.max(1, scrollElement.clientWidth);
              const direction = subjectScrollState.canScrollRight || !subjectScrollState.canScrollLeft ? 1 : -1;
              const viewportRect = scrollElement.getBoundingClientRect();
              const items = Array.from(scrollElement.querySelectorAll('.subjectMenu > span'));
              const targetItem = direction > 0
                ? items.find((item) => item.getBoundingClientRect().right > viewportRect.right + 1)
                : [...items].reverse().find((item) => item.getBoundingClientRect().left < viewportRect.left - 1);
              if (targetItem) {
                const maxScroll = Math.max(0, scrollElement.scrollWidth - scrollElement.clientWidth);
                const preferredTargetLeft = Math.max(
                  0,
                  Math.min(maxScroll, scrollElement.scrollLeft + direction * pageWidth)
                );
                let targetLeft = preferredTargetLeft;

                if (scrollElement.closest('.academicSubjectStrip')) {
                  const itemPositions = items.map((item) => {
                    const itemRect = item.getBoundingClientRect();
                    const left = itemRect.left - viewportRect.left + scrollElement.scrollLeft;
                    return { left, right: left + itemRect.width };
                  });
                  const gaps = [];
                  if (itemPositions.length) {
                    gaps.push({ start: 0, end: itemPositions[0].left });
                    for (let index = 1; index < itemPositions.length; index += 1) {
                      gaps.push({ start: itemPositions[index - 1].right, end: itemPositions[index].left });
                    }
                    gaps.push({
                      start: itemPositions[itemPositions.length - 1].right,
                      end: scrollElement.scrollWidth,
                    });
                  }

                  const edgeInset = 0.5;
                  const wholeLabelTargets = [];
                  gaps.forEach((leftGap) => {
                    gaps.forEach((rightGap) => {
                      const lowestTarget = Math.max(
                        0,
                        leftGap.start + edgeInset,
                        rightGap.start + edgeInset - pageWidth
                      );
                      const highestTarget = Math.min(
                        maxScroll,
                        leftGap.end - edgeInset,
                        rightGap.end - edgeInset - pageWidth
                      );
                      const directionMin = direction > 0 ? scrollElement.scrollLeft + 1 : lowestTarget;
                      const directionMax = direction > 0 ? highestTarget : scrollElement.scrollLeft - 1;
                      const allowedMin = Math.max(lowestTarget, directionMin);
                      const allowedMax = Math.min(highestTarget, directionMax);
                      if (allowedMin <= allowedMax) {
                        wholeLabelTargets.push(
                          Math.max(allowedMin, Math.min(allowedMax, preferredTargetLeft))
                        );
                      }
                    });
                  });

                  if (wholeLabelTargets.length) {
                    targetLeft = wholeLabelTargets.reduce((closest, candidate) => (
                      Math.abs(candidate - preferredTargetLeft) < Math.abs(closest - preferredTargetLeft)
                        ? candidate
                        : closest
                    ), wholeLabelTargets[0]);
                  }
                }

                scrollElement.scrollTo({ left: targetLeft, behavior: 'smooth' });
              } else {
                scrollElement.scrollBy({ left: direction * pageWidth, behavior: 'smooth' });
              }
              window.dispatchEvent(new CustomEvent('academic-subject-page', { detail: { direction } }));
            }}
          >{subjectScrollState.canScrollRight || !subjectScrollState.canScrollLeft ? '›' : '‹'}</button>
        )}
      </div>
 

</div>

        {showCategoryBanner && (
          <div className="academicImmediateBanner">
            <AdsComponent />
          </div>
        )}


     

{showAllPage ? (
    <>
      {location.pathname.toLowerCase().includes('/views/academic') && selectedClass ? (
        <AcademicAllLessons
          selectedClass={selectedClass}
          subjects={currentSubjects}
        />
      ) : (
        <AllPage
          page={location.pathname.split("/").pop()}
          selectedStage={selectedAcademicStage}
        />
      )}
    </>
  ) : null}
{showEnglishMenu ? (
   <>
     <div
       ref={lessonDropdownRef}
       className="subjectDropdown backendLessonDropdown"
       style={{ top: lessonMenuPosition.top, left: lessonMenuPosition.left }}
       onMouseEnter={clearLessonMenuCloseTimer}
       onMouseLeave={scheduleLessonMenuClose}
     >
      {lessonHasOverflow && <button
        type="button"
        className="lessonMenuScrollButton lessonMenuScrollUp"
        aria-label="Scroll lessons up"
        onClick={() => lessonMenuScrollRef.current?.scrollBy({ top: -180, behavior: 'smooth' })}
      >▲</button>}
      <ul ref={lessonMenuScrollRef}>
        {dropdownLoading ? (
          <li className="lessonDropdownStatus">Loading lessons…</li>
        ) : dropdownLessons.length > 0 ? (
          dropdownLessons.map((lesson) => (
            <li
              key={lesson}
              className={selectedSubject === dropdownSubject && selectedAcademicLesson === lesson ? 'selectedLesson' : ''}
              onClick={() => {
                setSelectedSubject(dropdownSubject);
                setAcademicBookType(dropdownBookType || null);
                setSelectedAcademicLesson(lesson);
                setSelectedAcademicStage(null);
                setShowAllPage(false);
                setShowEnglishMenu(false);
                const academicSelection = {
                  selectedClass,
                  selectedSubject: dropdownSubject,
                  bookType: dropdownBookType,
                  lesson,
                };
                if (currentCategoryModule === 'sections') {
                  navigate('/views/academic', { state: { academicSelection } });
                  return;
                }
                window.dispatchEvent(new CustomEvent('academic-selection-changed', { detail: academicSelection }));
              }}
            >
              {String(lesson).replace(/_/g, ' ')}
            </li>
          ))
        ) : (
          <li className="lessonDropdownStatus">No lessons available for this backend selection</li>
        )}
      </ul>
      {lessonHasOverflow && <button
        type="button"
        className="lessonMenuScrollButton lessonMenuScrollDown"
        aria-label="Scroll lessons down"
        onClick={() => lessonMenuScrollRef.current?.scrollBy({ top: 180, behavior: 'smooth' })}
      >▼</button>}
    </div>
  </>
  ) : null}
   </>
  ) : null}

  <Outlet ref={headerRef} />

</div>
        <Footer />
      </div>
    );
  }
};
export default ScreenInitializer;
// import "./Allpage.css";
// import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
// const academicData  = [
//   {
//     title: "FOUNDATIONAL",
//     subtitle: "CLASSES 1-2",
//     items: [
//       "Pre-school shapes work sheets",
//       "Number and pre-math work sheets",
//       "Pre-school Concepts work sheets",
//       "Pre-school Colouring work sheets",
//       "Alphabet work sheets",
//       "Activity work sheets",
//     ],
//   },
//   {
//     title: "PREPARATORY",
//     subtitle: "CLASS 3-4-5",
//     items: [
//       "Alphabet activities",
//       "Mathematics",
//       "Shapes games",
//       "Colourful activities",
//       "Basic Concepts",
//       "Vocabulary",
//     ],
//   },
//   {
//     title: "MIDDLE STAGE",
//     subtitle: "CLASSES 6-7-8",
//     items: [
//       "Count, Colour and Think",
//       "Times Tables",
//       "Number Detective",
//       "Secret Code",
//       "Number Patterns",
//     ],
//   },
//   {
//     title: "SECONDARY",
//     subtitle: "CLASS 9-10-11-12",
//     items: [
//       "Word World",
//       "Compound Words",
//       "Rhyming Fun",
//       "Alphabetical Order",
//       "Educational chart",
//     ],
//   },
// ];
// const enrichData = [
//   {
//     title: "ENGLISH",
//     // subtitle: "CLASSES 1-2",
//     items: [
//       "Grammar",
//       "Reading",
//       "Writing",
//       "Vocabulary",
//       "Comprehension",
//     ],
//   },
//   {
//     title: "MATHEMATICS",
//     // subtitle: "CLASSES 3-5",
//     items: [
//       "Numbers",
//       "Addition",
//       "Subtraction",
//       "Fractions",
//       "Geometry",
//     ],
//   },
//   {
//     title: "SCIENCE",
//     // subtitle: "CLASSES 6-8",
//     items: [
//       "Physics",
//       "Chemistry",
//       "Biology",
//       "Experiments",
//     ],
//   },
//   {
//     title: "SOCIAL",
//     // subtitle: "CLASSES 9-12",
//     items: [
//       "History",
//       "Geography",
//       "Civics",
//       "Economics",
//     ],
//   },
// ];

// export default function AllPage({ page }) {  
//   const data = page === "early-career"
//   ? enrichData
//   : academicData;
//   return (
//   <div
//   className="allWrapper"
//   style={{
//     background:
//       page === "academic"
//         ? "#5e94fe"
//         : page === "early-career"
//         ? "#a8de78"
//         : "#5e94fe",
//   }}
// >
//       {data.map((section, index) => (
//         <div className="allColumn" key={section.title}>
//          <div className={`allHeading ${index === 0 ? "activeHeading" : ""}`}>
//             <span className="headingTitle">{section.title}</span>
//     <span className="headingSubTitle">{section.subtitle}</span>
//           </div>

//           <ul>
//             {section.items.map((item) => (
//               <li key={item}>{item}</li>
//             ))}
//           </ul>

//          <div className="circleArrow">
//     <KeyboardArrowDownIcon />
// </div>
//         </div>
//       ))}
//     </div>
//   );
// }
